import axios from 'axios'

const APICore = 'https://viacep.com.br/ws'

// ViaCEP é API pública com Access-Control-Allow-Origin: * — não aceita request com credentials.
// Por isso axios puro e não o APIClient (withCredentials: true + Bearer em dev → erro de CORS).
const GetByZipCode = (zipcode, config = {}) => axios.get(`${APICore}/${zipcode}/json`, config)

const ZipCodeRepository = {
  GetByZipCode
}

export default ZipCodeRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/geo/zipCode.js